// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mb14[data-v-56ff9940] {\n  margin-bottom: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
